import { JsonProperty, JsonObject } from 'typescript-json-serializer';

/**
 * Container class for QR code information
 *
 * @export
 * @class QrCodeSource
 */
@JsonObject()
export class QrCodeSource {
  @JsonProperty('StationId') stationId: string;
  @JsonProperty('StationName') stationName: string;
  @JsonProperty('ConnectorCount') connectorCount: number;
  @JsonProperty('OwnerId') ownerId: number;
  @JsonProperty('OwnerUsername') ownerUsername: string;
}
